export default {
	namespaced: true,
	state: () => ({
		user: null,
		users: []
	})
}